
import Main from './main.vue';

let instance;
let calkBackList = [];

let CitySelectConstructor = Vue.extend(Main);
let data
// t端默认唤起原生城市选择s
let openTcBridgeMap = true;
let sortCityList = {};
let selectCity = {
    cityId: '321',
    cityName: '上海',
    lon: '121.47', //经度
    lat: '31.23', //纬度
    type: 'default'
}
// t端默认唤起原生城市选择e
const CitySelect = function (...options) {
    let calkBack = options && options[0] && options[0].callback || null
    data = options && options[0] && options[0].data || null
    calkBackList[0] = calkBack;
    if (data && data.openTcBridgeMap === false) { //只有false时生效
        openTcBridgeMap = data.openTcBridgeMap
    }
    if ((window.AllBridge.clientType === window.AllBridge.ClientTypeEnum.TAPP) && openTcBridgeMap) {
        window.AllBridge.ready().then((res) => {
            getLocateCity(calkBackList, data)
        })
    } else {
        if (instance) {
            instance.visible = true
            instance.needShowSearch = data && data.needShowSearch === false ? data.needShowSearch : true
            instance.needCustomizeData = data && data.needCustomizeData
            instance.customizeHotCity = data && data.customizeHotCity
            instance.hideHotCity = data && data.hideHotCity
            instance.appointCity = data && data.appointCity
            instance.useNewestStyle = data && data.useNewestStyle
            instance.needLocateFlag = data && data.needLocateFlag === false ? data.needLocateFlag : true //是否展示定位城市，走定位逻辑
            instance.locateType = data && data.locateType ? data.locateType : 1
            instance.afterOpen('modal-open')
            return
        }

        instance = new CitySelectConstructor({
            data() {
                return {
                    popType: data && data.popType || null,
                    needShowSearch: data && data.needShowSearch === false ? data.needShowSearch : true,
                    needCustomizeData: data && data.needCustomizeData,
                    customizeHotCity: data && data.customizeHotCity,
                    hideHotCity: data && data.hideHotCity,
                    appointCity: data && data.appointCity,
                    useNewestStyle: data && data.useNewestStyle,
                    needLocateFlag: data && data.needLocateFlag === false ? data.needLocateFlag : true, //是否展示定位城市，走定位逻辑
                    locateType: data && data.locateType ? data.locateType : 1
                }
            },
            methods: {
                choose(item) {
                    localStorage.selectCityObj = JSON.stringify(item)
                    // Object.assign(item, data)//将data合并给item  数据传递太多，影响后续交互，故注释
                    calkBackList[0] && typeof (calkBackList[0]) === 'function' && calkBackList[0](item)
                    this.hideCity()
                }
            }
        });
        instance.$mount();
        document.body.appendChild(instance.$el);
        return instance
    }
}

// 对数据进行排除处理
function insertSort(arr) {
    let len = arr.length
    for (let i = 1; i < len; i++) {
        let key = arr[i]
        let j = i - 1
        while (j >= 0 && arr[j].title > key.title) {
            arr[j + 1] = arr[j]
            j--
        }
        arr[j + 1] = key
    }
    return arr
}
// 获取城市列表数据
function getCityList(calkBackList) {
    window.AllBridge
        .request({
            method: 'post',
            url: 'https://tcmobileapi.17usoft.com/activityservice/common/queryDomesticCityList',
            data: { cityVersion: 1 },
        })
        .then((res) => {
            if (
                res &&
                res.data &&
                res.data.statusCode == 0 &&
                res.data.data
            ) {
                let body = JSON.parse(res.data.data)
                let sortCityList = {
                    domesticTags: [],
                    foreignTags: [],
                }
                let userObj = {}
                let hotDomestics = []
                body.map(function (item, index) {
                    let obj = {}
                    obj.cName = item.name
                    obj.cPY = item.namePY
                    obj.cPYS = item.initialMultiplePY
                    obj.countryId = item.countryId
                    obj.cityId = item.cityId

                    if (selectCity.cityName == item.name) {
                        userObj = obj
                    }
                    if (item.isHot == '1') {
                        hotDomestics.push(obj)
                    }
                    let find = false
                    sortCityList.domesticTags.forEach(function (
                        tag,
                        index
                    ) {
                        if (tag.title == item.initialSinglePY) {
                            find = true
                            tag.cityList.push(obj)
                        }
                    })
                    if (!find) {
                        let tag = {}
                        tag.title = item.initialSinglePY
                        tag.longTitle = item.initialSinglePY
                        tag.cellType = 'grid'
                        tag.cityList = []
                        tag.cityList.push(obj)
                        sortCityList.domesticTags.push(tag)
                    }
                })
                sortCityList.domesticTags = insertSort(
                    sortCityList.domesticTags
                )
                sortCityList.domesticTags.unshift({
                    title: '热门',
                    longTitle: '热门',
                    cellType: 'grid',
                    cityList: hotDomestics,
                })
                if (userObj.cName && userObj.cName.length && selectCity.type === 'locate') {
                    sortCityList.domesticTags.unshift({
                        title: '当前',
                        longTitle: '当前 定位',
                        cellType: 'grid',
                        cityList: [userObj],
                    })
                }

                if (sortCityList && sortCityList.domesticTags) {
                    initSelectCity(sortCityList, calkBackList)
                }
            } else {
                console.log('getCityList res:', res)
            }
        })
        .catch((err) => {
            console.log('getCityList err:', err)
        })
}
// 获取定位城市信息
function getLocateCity(calkBackList, data) {
    console.log('ui citySelct app_location params cacheType', data && data.appCacheType)
    console.log('ui citySelct app_location realParams cacheType', {
        showType: "1",
        cacheType: data && data.appCacheType || "3"
    })
    _tc_bridge_map.app_location({
        param: {
            showType: "1",
            cacheType: data && data.appCacheType || "3"
        },
        callback: function (data) {
            console.log('ui citySelct app_location callback org:', data)
            let res = data && data.CBData && JSON.parse(data.CBData).locationInfo
            console.log('ui citySelct app_location callback res:', res)
            if (res && res.cityId) {
                selectCity = {
                    cityId: res.cityId,
                    cityName: res.cityName,
                    lon: res.lon, //经度
                    lat: res.lat, //纬度
                    type: 'locate'
                }
            }
            getCityList(calkBackList)
        }
    })

}
// 初始化城市选择
function initSelectCity(data, calkBackList) {
    _tc_bridge_map.select_city({
        param: {
            title: '选择城市',
            sName: selectCity.type === 'locate' ? selectCity.cityName : '',
            tabType: 'left',
            cityConfig: [
                {
                    subTitle: '国内',
                    tips: '请输入城市名称(如北京,bj,Beijing)',
                    allCitys: JSON.stringify({
                        cellType: 'grid',
                        tagList: data.domesticTags,
                    }),
                },
            ],
        },
        callback: (data) => {
            selectCity.lon = ''
            selectCity.lat = ''
            let res = data.CBData
            handleSelectCity(JSON.parse(res), calkBackList)
        },
    })
}
// 选择的城市进行格式化统一处理
function handleSelectCity(city, calkBackList) {
    window.AllBridge.request({
        url: '/actgateway/marketcenter.java.activity.resource.service/v2/city/getCityInfoFromSearch',
        method: 'get',
        params: {
            cityName: city.cityInfo.cName,
            tcCityId: '',
            lon: '',
            lat: '',
            refreshCache: '',
            likeSearch: true,
        }
    }).then((res) => {
        let data = res.data
        if (data.code === '0000') {
            let item = {
                latitude: data.result[0].latbd, //纬度	Number	-
                longitude: data.result[0].lonbd, //经度	Number	-
                provName: data.result[0].provName, //省份名称	String	-
                cityName: data.result[0].nameShort, //城市名称	String	-
                tcProvId: data.result[0].provId, //同程省份Id	Number	-
                tcCityId: data.result[0].id, //同程城市Id	Number	-
                threeCode: data.result[0].threeCode,
                elCityId:
                    (data.result[0].eRegion && data.result[0].eRegion.euId) ||
                    '', //艺龙城市Id	String
            }

            calkBackList[0] && typeof (calkBackList[0]) === 'function' && calkBackList[0](item)
        }
    }).catch(error => console.error(error.code, error.message))
}
export default CitySelect;